// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__28n6w","title":"ClientInsurance_title__17OGf","itemText":"ClientInsurance_itemText__1ev_j"};